import GenerateQRPage from "presentation/pages/view/generate-qr/GenerateQRPage";
import useGenerateQRViewModel from "presentation/pages/viewmodel/generate-qr";

export default function GenerateQR () {
    const viewModel = useGenerateQRViewModel();

    return <GenerateQRPage viewModel={viewModel} />;
}